<div class="trigger" (click)="open()" cdkOverlayOrigin #trigger="cdkOverlayOrigin">
  <ng-content select="[xTrigger]"></ng-content>
</div>

<ng-template
  xOverlayResponsiveHeight
  #overlay="xOverlayResponsiveHeight"
  cdkConnectedOverlay
  [cdkConnectedOverlayHasBackdrop]="true"
  [cdkConnectedOverlayPanelClass]="['fullwidth', 'fullscreen-dialog-mobile']"
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="(openOverlay$ | async) ?? false"
  [cdkConnectedOverlayHeight]="(overlay.height$ | async) ?? ''"
  (overlayOutsideClick)="handleOutSideClick($event)"
  (overlayKeydown)="overlayKeyDown($event)"
>
  <x-overlay-content>
    <x-triangle [target]="trigger"></x-triangle>
    <x-region-overlay></x-region-overlay>
  </x-overlay-content>
</ng-template>
